import { render, staticRenderFns } from "./EmployeesApps.vue?vue&type=template&id=2bf2ebbb"
import script from "./EmployeesApps.vue?vue&type=script&lang=js"
export * from "./EmployeesApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports